<template>
    <!-- Don't remove this div -->
    <div>
        <div class="product-coverage-table">
            <div class="row heading-row text-center no-gutters">
                <div
                    class="col-3 col-sm"
                    v-for="(productFeature, index) in products"
                    v-bind:key="index"
                >
                    <div class="heading p-2 d-flex align-items-center justify-content-center">
                        <span>{{ productFeature.feature_name }}</span>
                    </div>
                </div>
            </div>

            <div class="row image-row text-center no-gutters">
                <div
                    v-for="(productFeature, index) in products"
                    v-bind:key="index + 2"
                    class="col-3 col-sm"
                >
                    <div class="p-1">
                        <img class="image lazyload" :data-src="productFeature.image"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col">
                <pagination
                    :total-pages="productFeaturesPerPage"
                    :total="this.productFeatures.length"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :showFirstLastButtons="false"
                    @pagechanged="(page) => (this.currentPage = page)"
                ></pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
    },
    computed: {
        products() {
            let toTake = this.perPage * this.currentPage;
            let from = toTake - this.perPage;

            return this.productFeatures.slice(from, toTake);
        },
        productFeaturesPerPage() {
            return Math.ceil(this.productFeatures.length / 12);
        },
    },
    props: {
        productFeatures: Array,
    },
    data() {
        return {
            perPage: 12,
            currentPage: 1,
        };
    },
    methods: {},
};
</script>
